import route from "@/components/router/Router";
import allItem from "./allitem/index";
import focusItem from "./focusitem/index";
import importantItem from "./importantitem/index";
import contactingItem from "./contactingitem/index";
import pauseItem from "./pauseitem/index";
import successedItem from "./successitem/index";
import allsuccessItem from "./allsuccessitem/index";
import seaItem from "./seaitem/index";
import recycledItem from "./recycleditem/index";
import inputItem from "./inputitem/index";
import inputcarrier from "./inputcarrier/index";
import allCarrier from "./allcarrier/index";
import focusCarrier from "./focuscarrier/index";
import recycledCarrier from "./recycledcarrier/index";

export default {
    path : "warehouse",
    name : "warehouse",
    meta : {
       title : "仓库"
    },
    component : route,
    children : [
        allItem,
        focusItem,
        importantItem,
        contactingItem,
        pauseItem,
        successedItem,
        allsuccessItem,
        seaItem,
        recycledItem,
        ...inputItem,
        allCarrier,
        focusCarrier,
        ...inputcarrier,
        recycledCarrier
    ],
}


// WEBPACK FOOTER //
// ./src/router/warehouse/indexRouter.js